import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../constants";
import { FaUserPlus } from "react-icons/fa";
import Toast from "../DetailsCompteur/Toast";

export default function AddUserForm({ token }) {
  const [mail, setMail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });
  const navigate = useNavigate();

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateEmail(mail)) {
      showToast('error', 'Adresse e-mail invalide.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(`${API_URL}/user/signupadmin`, {
        email: mail,
        isAdmin: isAdmin,
      }, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      showToast('success', response.data.message || 'Utilisateur créé avec succès !');
      setMail("");
      setIsAdmin(false);
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      if (error.response?.status === 401) {
        alert("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear();
        navigate("/login");
        return;
      }
      const message = error.response?.data?.error || "Échec de la création de l'utilisateur.";
      showToast('error', message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-emerald-400 flex items-center justify-center shrink-0">
          <FaUserPlus className="text-white text-sm" />
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Ajouter un utilisateur</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="bg-gray-50 rounded-xl p-5 space-y-4">
          <input
            className="w-full border border-gray-300 rounded-lg px-4 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-green-400"
            type="email"
            name="mail"
            placeholder="Adresse mail"
            onChange={(e) => setMail(e.target.value)}
            value={mail}
          />

          <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer w-fit">
            <input
              type="checkbox"
              checked={isAdmin}
              onChange={(e) => setIsAdmin(e.target.checked)}
              className="w-4 h-4 accent-green-500"
            />
            Administrateur
          </label>
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="w-full sm:w-auto bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50"
        >
          {submitting ? 'Création...' : 'Ajouter'}
        </button>
      </form>

      <Toast type={toast.type} message={toast.message} />
    </div>
  );
}